import styled from 'styled-components';

import theme from '../../styles/theme';
import banner from '../../../static/image/banner-footer.jpg';

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 300px;
  background: url(${banner});
  justify-content: center;
  align-items: center;
  padding: 0 20%;

  @media (max-width: 600px) {
    padding: 0 20px;
  }
`;

export const Text = styled.span`
  color: ${theme.accent};
  font-weight: normal;
  font-size: 28px;
  text-align: center;
  margin: 0px;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

export const TextHighlight = styled.mark`
  color: ${theme.primary};
  font-weight: bold;
  font-size: 28px;
  text-align: center;
  margin: 0px;
  background-color: transparent;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;
